<template>
	<div :class="modal ? 'modal is-active' : 'modal'">
  	<div class="modal-background"></div>
  	<div class="modal-card is-small">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title">Sign Out</p>	
      </header>
      <section class="modal-card-body ph20 has-text-centered">
        <img src="@/assets/img/sign-out.svg" alt="email" class="mb20 mt20">
        <p class="is-size-14 mb10">Are you sure you want to sign out?</p>
      </section>
      <footer class="modal-card-foot">
        <div class="next-prev-button">
          <button @click="signOut()" class="button is-large bg-secondary hover-opacity-7 text-white is-full-width">Yes, Sign Out</button>
          <button @click="closeModal()" class="button is-large is-white is-full-width br10">No, Cancel</button>
        </div>
      </footer>
	  </div>
	</div>
</template>

<script>
import Env from '@/env';
import PubNub from 'pubnub';
import { mapGetters, mapActions } from "vuex";
import UserApis from '@/Components/Controllers/UserApis';
import Helpers from '@/Components/Helpers/Helpers';

export default {
  data() {
    return {
      modal: false,
    };
  },

  computed: {
    ...mapGetters({
      vg_locationSelected: "location/selected",
    })
  },
  
  mounted() {
    bus.$on('show-modal-sign-out', (payload) => {
      this.modal = payload;
    })
  },

  beforeDestroy() {
    bus.$off('show-modal-sign-out');
  },

  methods: {
    closeModal() {
      this.modal = false;
    },
    /**
     * Sign out
     */
    async signOut() {

      this.va_setUserLoyalityObj({});
      Helpers.pubnubUnSubscribeAllChannels({
        user_id: this.$store.getters.getLoggedInUserId,
        location_id: this.vg_locationSelected.id,
      });

      // remove local data either lout out fail or true
      let res = await UserApis.logout();
      // remove Fb cache if any
      if(window.FB != undefined){
        window.FB.getLoginStatus((fbloginRes) =>{
          if(fbloginRes.status == 'connected'){
            window.FB.logout(function(){
              console.log('fb out.')
            });
          }
        })
      }
      
      this.va_snackbar({
        type: res.status == 200 ? 'success' : 'warning',
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
      // Now we dont need to send on home page rather send to location page
      this.va_clearCart();
      this.$store.dispatch('REMOVE_APP_DATA', '');
      this.closeModal();
      let queryToremove =  ['user_token','verify_email', 'category', 'token', 'signup', 'source', 'signup_token'];
      let pureQueries = Helpers.refineQuery(queryToremove,this.$route.query)

      if(_.isEmpty(this.vg_locationSelected.slug)){
        this.$router.push({ 
          name: 'HomePage', 
          param: { 
            business_slug: this.$route.params.business_slug 
          },
          query: pureQueries,
        }); //  query: this.$route.query
      } else {
        if(this.$route.name != 'StoreProfile'){
          this.$router.push({ 
            name: 'StoreProfile', 
            params: { 
              business_slug: this.$route.params.business_slug,  
              store_slug: this.vg_locationSelected.slug 
            },
            query: pureQueries 
          }) // query: this.$route.query
        } 
      }
    },

    ...mapActions({
      // va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_clearCart: "cart/clearCart",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
    })
  },
};
</script>